import React from "react";
import { getCardImage } from "../resultVisuals/cardAssets";

const WINNER_IMG = `${import.meta.env.BASE_URL}img/winner.png`;

function PlayerCards({ name, cards, isWinner }) {
  return (
    <div className="casino-result-content-item text-center">
      <div className="casino-result-cards">
        {isWinner && (
          <div className="casino-result-cards-item">
            <img src={WINNER_IMG} className="winner-icon" alt="" />
          </div>
        )}{" "}
        <div className="d-inline-block">
          <h4>{name}</h4>
          {cards.map((c, i) => (
            <React.Fragment key={i}>
              {" "}
              <div className="casino-result-cards-item">
                <img src={getCardImage(c)} alt="" />
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}

/**
 * Reference result body for 20-20 Teenpatti (teen20 / pteen20 / vteen20 / teen20b):
 * cards A=[0,2,4], B=[1,3,5], trophy before the winner's cards; rdesc
 * "winner#baccarat~detail#total#pairplus#redblack". teen20b labels the last row "Color";
 * vteen20 adds the .vteen20 class on .casino-result-desc.
 */
export default function Teen20ResultBody({ t1, gameType = "teen20" }) {
  const type = String(gameType || "").toLowerCase();
  const cards = String(t1?.card || "").split(",").map((c) => c.trim());
  const pick = (idx) => idx.map((i) => cards[i]);
  const win = String(t1?.win ?? "");
  const desc = t1?.rdesc ? String(t1.rdesc).split("#") : [];
  const bacc = String(desc[1] ?? "").split("~");
  const lastLabel = type === "teen20b" || type === "teen20c" ? "Color" : "Red Black";

  return (
    <div className="row row5">
      <div className="col-12 col-lg-8">
        <div className="casino-result-content">
          <PlayerCards name="Player A" cards={pick([0, 2, 4])} isWinner={win === "1"} />{" "}
          <div className="casino-result-content-diveder" />{" "}
          <PlayerCards name="Player B" cards={pick([1, 3, 5])} isWinner={win === "2"} />
        </div>
      </div>{" "}
      <div className="col-12 col-lg-4">
        {desc.length > 0 && (
          <div className={`casino-result-desc${type === "vteen20" ? " vteen20" : ""}`}>
            <div className="casino-result-desc-item">
              <div>Winner</div> <div>{desc[0]}</div>
            </div>{" "}
            <div className="casino-result-desc-item">
              <div>3 Baccarat</div> <div>{bacc[0]}</div>
            </div>{" "}
            <div className="casino-result-desc-item">
              <div /> <div>{bacc[1]}</div>
            </div>{" "}
            <div className="casino-result-desc-item">
              <div>Total</div> <div>{desc[2]}</div>
            </div>{" "}
            <div className="casino-result-desc-item">
              <div>Pair Plus</div> <div>{desc[3]}</div>
            </div>{" "}
            <div className="casino-result-desc-item">
              <div>{lastLabel}</div> <div>{desc[4]}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
